import { FilterMatchMode } from "primereact/api";

export class RefPersonal {

    model = {
        id: {
            value: null,
            export: true,
            header: 'Código',
            table: false,
            filter: true,
            filterPlaceholder: 'Buscar por código',
            filterField: 'id',
            sort: true,
            matchMode: FilterMatchMode.EQUALS,
            showFilterMatchModes: false,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },
        nombre_completo: {
            value: '',
            export: true,
            header: 'APELLIDOS Y NOMBRES',
            table: true,
            sort: false,
            filter: true,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'nombre_completo',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
        },
        telefono: {
            value: '',
            export: true,
            header: 'NO. DE TELÉFONO',
            table: true,
            sort: false,
            filter: true,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'telefono',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 40 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 40,
            min: 4,
        },
        parentesco: {
            value: '',
            export: true,
            header: 'PARENTESCO',
            table: true,
            sort: false,
            filter: true,
            filterPlaceholder: 'Buscar',
            filterField: 'parentesco',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 250,
            min: 4,
        },
        direccion_domicilio: {
            value: '',
            export: true,
            header: 'DIRECCION DOMICILIARIA',
            table: true,
            sort: false,
            filter: true,
            filterPlaceholder: 'Buscar',
            filterField: 'direccion_domicilio',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 250,
            min: 4,
        },
    }
}